import React, { useMemo } from "react";

import useStrategyDashboardChartMarketFromUrl from "../../../../../hooks/useStrategyDashboardChartMarketFromUrl";
import {
  getStrategyDashboardChartMarkets,
  mergeStrategyDashboardTableDefaultSettings
} from "../../../../../lib/StrategyDashboard/strategyDashboardChartMarkets";
import { STRATEGY_DASHBOARD_IDS } from "../../../../../lib/StrategyDashboard/strategyDashboardConfig";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import UniversalTableLiteWeb from "../../../common/UniversalTableLiteWeb";
import StrategyViewFullSignalsTableLink from "./StrategyViewFullSignalsTableLink";

const StrategySignalsTable = ({ preview = false }) => {
  const dashboard = useStrategyDashboardConfig();
  const table = dashboard.signalsTable;
  const chartMarkets = useMemo(
    () => getStrategyDashboardChartMarkets(dashboard),
    [dashboard]
  );
  const { tableMarketFilters } =
    useStrategyDashboardChartMarketFromUrl(chartMarkets);

  const defaultSettings = useMemo(
    () =>
      preview
        ? {
            pagination: {
              current: 1,
              rowsPerPage: 8
            }
          }
        : {},
    [preview]
  );

  const initialSettings = useMemo(() => {
    const merged = mergeStrategyDashboardTableDefaultSettings(
      {},
      tableMarketFilters
    );

    return Object.keys(merged).length > 0 ? merged : null;
  }, [tableMarketFilters]);

  if (!table) {
    return null;
  }

  return (
    <UniversalTableLiteWeb
      dataTestId={
        dashboard.id === STRATEGY_DASHBOARD_IDS.TREND
          ? "trend-strategy-signals-table"
          : undefined
      }
      resourceId={table.resourceId}
      fitColumns={Boolean(table.fitColumns)}
      stackZoneEdges={Boolean(table.stackZoneEdges)}
      options={preview ? { skipAccessCheck: true } : undefined}
      belowTable={preview ? <StrategyViewFullSignalsTableLink /> : undefined}
      usePagination={true}
      hideLoadMore={preview}
      defaultSettings={defaultSettings}
      initialSettings={initialSettings}
      useUrlSettings={!preview}
    />
  );
};

export default StrategySignalsTable;
